
//
// Misc shared that is needed by both myscript and grapher
// TODO needs much better refactoring
//
// console.log("shared.js loaded");
const TOOLIDENTIFIER = "DICopilot";   // Used in slack messages
export var userSessionIdentifier;    // This gets updated later to include the cid
userSessionIdentifier = TOOLIDENTIFIER;    // This gets updated later to include the cid
export var gitHash;
export const USE_SLACKBOT = true; // There are two ways to send messages to slack: a webhook and a slackbot. the slackbot has more power and will be used for slash commands and more.  but we're retaining the old mechanism, for now.

export const DISPLAYERRORSONUSERSCREEN = false; // TODO: Should go into config object
export const channelID = "C076A3S2VU1"; // Slack ID for channel to which to send user messages. Note that atm this is "dicopilot-interactions" in the Q slack

// This is a mutable object pattern, so that we can update the globalUserMessage from outside functions
export const sharedState = {
  globalUserMessage: "", // Initial value
  totalTokensInMessages: 0,
  messages: [],
};


var chatBox;
$(document).ready(() => {
  // Wait for the doc to be ready before initializing the chat box
    chatBox = $("#chat-box");
    // Now `chatBox` refers to the correct element
});


// Create unique ID for this commit so we can report it for debugging purposes
// assumes "dogithash" has been run to create this file based on the current github commit hash ID
gitHash = await readFromFile("../data/githash.txt");
gitHash = gitHash.trim();
// console.log("Just read gitHash: " + gitHash);

// Get a hash code to use for slack tracing 
export async function sendSlackMessage(gitHash, message) {

  const serverName = window.location.hostname;

  message = serverName + ":" + gitHash + ": " + message;

  // There are two mechanisms to send information to slack: a slackbot and a webhook.
  // The slackbot is newer code; keeping the webhook here in case something goes wrong
  if (USE_SLACKBOT) {
    const botToken = 'xoxb-197864483633-7213780206849-9ulF2D20CqDgrl4Cp69A6azf'; // Replace with your actual bot token

    const url = 'https://slack.com/api/chat.postMessage';

    message = {
        //token: botToken,
        channel: channelID,
        text: message
    };
    try {
        // TODO this code drives a CORS error unless you install a browser workaround.  So for production we'll have to create a proxy server
        // See https://chatgpt.com/c/24083cdb-5026-4d54-bca5-651177bd6705 for specifics
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${botToken}`
            },
            body: JSON.stringify(message)
        });

      if (!response.ok) {
            const errorDetails = await response.text();
            throw new Error(`HTTP error! Status: ${response.status}, Details: ${errorDetails}`);
        }

        const data = await response.json();
        if (!data.ok) {
            console.error('Error sending message:', data.error);
        } else {
            // TODO maybe put a debugging flag here
            //console.log('Message sent:', data);
        }
    } catch (error) {
        console.error('Fetch error:', error);
    }

}
  else {
    // use older webhook mechanism instead of slackbot

    // TODO needs to be in a config file
    const q_slack_url =
      "https://hooks.slack.com/services/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"; // For lens channel ?? <--TODO LENS?
    const vendor_slack_url = "";
    const data = {
      text: message,
    };

    $.ajax({
      url: q_slack_url,
      type: "POST",
      headers: {},
      data: JSON.stringify(data),
      success: function (response) {
        //console.log('Message sent at quantellia2:', response);
      },
      error: function (error) {
        console.error(
          `Error sending ${userSessionIdentifier} slack message to quantellia slack: ${error.responseText}`
        );
      },
    });

    // TODO node this is === not == because == was evaluating to true when 
    // VENDOR_SLACK_TRACE was false and ChatConfig.logs was undefined
    if (ChatConfig.logs === ChatConfig.VENDOR_SLACK_TRACE) {
      $.ajax({
        url: vendor_slack_url,
        type: "POST",
        headers: {},
        data: JSON.stringify(data),
        success: function (response) {
          //console.log('Message sent at quantellia2:', response);
        },
        error: function (error) {
          console.error(
            `Error sending ${userSessionIdentifier} slack message to quantellia slack: ${error.responseText}`
          );
        },
      });
    }
  }
}

export async function readFromFile(filePath) {
  // console.log(`About to read file: ${filePath}`);
    try {
      const response = await fetch(filePath,{cache:"no-store"});
      if (response.ok) {
            console.log("read file:"+filePath);

        const data = await response.text();
        return data;
      } else {
        throw new Error('Failed to fetch file');
      }
    } catch (error) {
      console.error(`Error while trying to fetch file: ${filePath}:`, error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }

export function parseJson(str) {
  var jsonData;
  try {
    jsonData = JSON.parse(str);
  }
  catch (error) {
    var errorString = "Error while parsing JSON from DICopilot: " + error + " " + error.stack;
    displayGrapherError(errorString);
    console.error(errorString);
  }
  return jsonData;
}

//
// Display an error in the user window
// TODO needs to be reationalized with displayError in main.js, which shouldn't be limited to that document's scope
// There should be only one function, accessible from any scope throughout, and this should go into a utilities.js or similar
//
export function displayGrapherError(error) {
  var errorMessage = `<div class="chat-message bot-message error-message"> Sorry, I have an error: <br/>  ${error}.<br/>Please try again, and you may want to report this error, too </div>`;

  if (DISPLAYERRORSONUSERSCREEN) {
    chatBox.append(errorMessage);
    chatBox.scrollTop(chatBox.prop("scrollHeight")); // Scroll to display this message
  }
  sendSlackMessage(`${userSessionIdentifier} error: ${errorMessage}`);
}

// Populate the label field by combining the element type and label
export function createNodeLabel(node) {

  if (!node.elementtype) node.elementtype = "Type not yet specified";
  if (!node.elementname) node.elementname = "Name not yet specified";

  return {
    ...node,
    // Note that the html here is very limited, see 
    // https://visjs.github.io/vis-network/examples/network/labels/labelMultifont.html
    // For more sophisticated html, see visjs examples for html embedded in svg
    label: `<b><i>${node.elementtype}:</i></b> ${node.elementname}`,
    // "<em>Ename!</i> (not bold): "+ node.elementname, // TODO: later this will be html built from node.elementtype and node.elementname
    // Note that vis.js specification says that this should be set during initialization
    // from the options json, but it's not, so I'm setting it explitly here
    font: {
      multi: "html",
      size: 18,
      // Specifies how to render anything tagged as both bold and italic
      boldital: {
        color: "darkblue",
      }
    }
  };
}

  //
  // Appends a message to the chat box. Uses different html based on user or bot message
  //
  export async function appendMessage(message, sender) {
    // const chatBox = $("#chat-box");

    // If we're in a potential three-way conversation then label
    // the user's input to make it clear who's talking.
    if (USE_SLACKBOT && sender === "user")
      message = "You: " + message;

    var messageClass = "bot-message";
    if (sender === "user") {
      messageClass = "user-message";
    }
    else if (sender === "humanadvisor"){ // TODO remove if jumpin not activated
      messageClass = "humanadvisor-message";
    }
    var messageElement = $(
      "<div class='chat-message " +
        messageClass +
        "'><p>" +
        message +
        "</p></div>"
    );
    chatBox.append(messageElement);
    chatBox.scrollTop(chatBox.prop("scrollHeight"));
  }

  // Appends a user message to the chat box
  export function appendUserMessage(message) {
    appendMessage(message, "user");
  }

  export function slackAndConsole(loggingLine, isError = true) {
    if (isError) {
      console.error(loggingLine);
    }
    else console.error(loggingLine);
    sendSlackMessage(loggingLine);
  }

  //
  // Display an error in the user window
  //
  export function displayError(error) {
    var errorMessage = `<div class="chat-message bot-message error-message"> Sorry, I have an error: <br/>  ${error}.<br/>Please try again, and you may want to report this error, too </div>`;

    if (DISPLAYERRORSONUSERSCREEN) {
      chatBox.append(errorMessage);
      chatBox.scrollTop(chatBox.prop("scrollHeight")); // Scroll to display this message
    }
    sendSlackMessage(`${userSessionIdentifier} error: ${errorMessage}`);
  }

  export function logMessagesArray() {
    console.log("Messages array:");
    // Loop through array and print each value
    for (let i = 0; i < sharedState.messages.length; i++) {
      console.log(`Entry ${i}: ${sharedState.messages[i].role}: ${sharedState.messages[i].content}`);
    }
  }